// extracted by mini-css-extract-plugin
export default {"contentEditable":"LexicalContentEditable_contentEditable__d8EG9","placeholder":"LexicalContentEditable_placeholder__EAmdU"};